<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card style="margin: 20px auto" header-color="primary">
        <h3 slot="title" class="title"><br />Log in</h3>

        <p slot="subheader" class="subheader">Please enter your user information</p>

        <md-field
          slot="inputs"
          :class="[{ 'md-form-group': true }, { 'md-error': errors.has('email') && emailTouched }]"
        >
          <md-icon>mail_outline</md-icon>
          <label>Email</label>
          <md-input
            v-model="user.username"
            type="email"
            v-validate="emailValidation"
            data-vv-name="email"
            name="email"
          />
          <slide-y-down-transition>
            <md-icon style="padding: 0" v-show="errors.has('email')" class="alert">close</md-icon>
          </slide-y-down-transition>
        </md-field>

        <md-field
          slot="inputs"
          :class="[{ 'md-form-group': true }, { 'md-error': errors.has('password') && passwordTouched }]"
        >
          <md-icon>lock_outline</md-icon>
          <label>Password</label>
          <md-input
            v-validate="'required'"
            v-model="user.password"
            type="password"
            data-vv-name="password"
            name="password"
          />
        </md-field>

        <span v-if="displaySpinner" slot="footer" style="margin-bottom: 15px; padding: 0">
          <img style="margin: 0; padding: 0; width: 50px" src="@/assets/img/plswait2.gif" />
        </span>
        <md-button v-else slot="footer" class="md-primary md-simple">&nbsp;</md-button>

        <md-button slot="footer" style="font-weight: 500" class="md-primary md-simple md-lg" @click="handleLogin(false)"
          >Sign In
        </md-button>

        <p v-if="loginError" slot="inputs" style="color: red; margin-bottom: 10px">{{ loginError }}</p>

        <span slot="footer" align="Left">
          <a href="#" style="font-size: 0.7rem; color: #000000de" @click="gotoReset">Reset Password</a>
          <br />
          <a href="#" style="font-size: 0.7rem; color: #000000de" @click="gotoHome">Cancel</a>
        </span>
      </login-card>
    </div>

    <!-- Verify Credentials Modal -->
    <md-dialog :md-active.sync="showVerifyCredentialsModal" :md-close-on-esc="false" :md-click-outside-to-close="false">
      <md-dialog-title>Verify Credentials</md-dialog-title>

      <md-dialog-content>
        <md-field>
          <label>Username</label>
          <md-input v-model="verifyCredentials.username"></md-input>
        </md-field>

        <md-field>
          <label>Password</label>
          <md-input v-model="verifyCredentials.password" type="password"></md-input>
        </md-field>

        <md-field>
          <label>Confirm Password</label>
          <md-input v-model="verifyCredentials.confirm_password" type="password"></md-input>
        </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showVerifyCredentialsModal = false">Cancel</md-button>
        <md-button class="md-primary" @click="verifyCredentialsSubmit">Verify</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import User from "../../models/user"
import { LoginCard } from "@/components"
import Swal from "sweetalert2"
import { SlideYDownTransition } from "vue2-transitions"

export default {
  components: {
    LoginCard,
    SlideYDownTransition
  },
  data() {
    return {
      username: null,
      email: null,
      password: null,
      error: false,
      status: null,
      token: null,
      dashSource: "",
      portalRoute: "",

      user: new User("", ""),
      loading: false,
      message: "",
      loginError: "",
      displaySpinner: false,
      emailValidation: {
        required: true,
        min: 6,
        regex: "^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"
      },
      showVerifyCredentialsModal: false,
      verifyCredentials: {
        username: "",
        password: "",
        confirm_password: ""
      },
      emailTouched: false,
      passwordTouched: false
    }
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    },

    isReset() {
      let rset = sessionStorage.getItem("rSet")
      if (rset == null) {
        return false
      } else {
        return rset
      }
    }
  },

  created() {
    if (this.loggedIn && sessionStorage.getItem("token")) {
      const portalRoute = sessionStorage.getItem("portalRoute");
      this.$router.push(portalRoute);
    }
  },

  mounted() {
    sessionStorage.clear()
    sessionStorage.setItem("rSet", false)
  },

  methods: {
    signIn() {
      this.clear()
    },
    gotoHome() {
      this.emailTouched = false
      this.passwordTouched = false
      this.$router.push("/")
    },
    gotoReset() {
      this.$router.push("/reset-psw")
    },

    clear() {
      this.error = null
      this.status = null
      this.token = null
    },

    handleVerifyCredentials() {
      this.showVerifyCredentialsModal = true
    },

    verifyCredentialsSubmit() {
      // Add your verification logic here
      if (this.verifyCredentials.password !== this.verifyCredentials.confirm_password) {
        alert("Passwords do not match")
        return
      }
      if (
        this.verifyCredentials.username == this.user.username &&
        this.verifyCredentials.password == this.user.password
      ) {
        // If verification is successful, close the modal and proceed with login
        this.showVerifyCredentialsModal = false
        sessionStorage.setItem("rSet", true)
        this.handleLogin(true)
      } else {
        this.showVerifyCredentialsModal = false
        this.loginError = "Credentials do not match. Please try again."
      }
    },

    validateCredentials() {
      if (this.user.username && this.user.password) {
        return true
      }
    },

    handleLogin(b) {
      this.emailTouched = true
      this.passwordTouched = true
      this.loginError = "" // Clear previous error messages
      return this.$validator.validateAll().then((valid) => {
        if (!valid) return

        this.displaySpinner = true
        this.loading = true
        if (b) {
          sessionStorage.setItem("rSet", true)
        }

        if (this.user.username && this.user.password) {
          const payload = {
            username: this.user.username,
            password: this.user.password,
            reset: b ? true : this.isReset
          }

          const getOrgId = JSON.parse(localStorage.getItem("currentOrg")).id
          if (!getOrgId) {
            this.loginError = "It was not possible to retrive information about this organization, please, reload the page and try again."
            this.displaySpinner = false
            return
          }

          this.$store.dispatch("auth/login", payload).then(
            (resp) => {
              // console.log("LOGIN Response: " + JSON.stringify(resp))

              if (resp) {
                if (JSON.stringify(resp).includes("Verify Credentials")) {
                  this.showVerifyCredentialsModal = true
                  return
                }
                this.getMemberInfo(resp)
              } else {
                this.displaySpinner = false
                this.loginError = "Please check your credentials and try again."
                return
              }
            },
            (error) => {
              this.displaySpinner = false
              this.loading = false
              this.loginError = "ERROR: Please try again."

              this.message = (error.response && error.response.data) || error.message || error.toString()
            }
          )
        }
      })
    },

    async getMemberInfo(res) {
      if (res) {
        const url = process.env.VUE_APP_URL + "/user/" + res.username;
        sessionStorage.setItem("token", res.token)
        const vm = this
        await window.axios
          .get(url)
          .then((response) => {
            sessionStorage.setItem("personID", response.data.id)
            sessionStorage.setItem("firstname", response.data.first_name)
            sessionStorage.setItem("lastname", response.data.last_name)
            sessionStorage.setItem("email", response.data.email)
            sessionStorage.setItem("username", response.data.email)
            sessionStorage.setItem("userID", response.data.user_id)
            sessionStorage.setItem("usertype", res.decoded.user_type)
            sessionStorage.setItem("role", res.decoded.role)
            sessionStorage.setItem("kioskid", response.data.kiosk_id)
            sessionStorage.setItem("memberDate", response.data.CreatedDate)

            // TODO user org id can be an array of ids
            sessionStorage.setItem("userOrgID", response.data.orgID)
            if (response.data.organisations && response.data.organisations.length > 0) {
              sessionStorage.setItem("userOrgID", response.data.organisations[0].Id)
            }
            sessionStorage.setItem(
              "userLocale",
              response.data.zipcode + "|" + response.data.city + "|" + response.data.state + "|" + response.data.country
            )
            sessionStorage.setItem("isTempPsw", response.data.isTempPsw)
            sessionStorage.setItem("organizations", JSON.stringify(res.organizations))

            if (localStorage.getItem('currentOrgSelectedForFilters') != 'all' && !res.organizations.find(i => i.orgId === localStorage.getItem('currentOrgSelectedForFilters'))) {
              localStorage.setItem('currentOrgSelectedForFilters', 'all')
            }

            vm.memberID = sessionStorage.getItem("userID")
            vm.memberName = sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
            vm.memberType = sessionStorage.getItem("usertype")
            vm.memberGlobe = sessionStorage.getItem("kioskid")
            vm.memberEmail = sessionStorage.getItem("email")

            switch (res.decoded.role) {
              case "Patient": // "Member"
                console.log("User is type: Member")
                sessionStorage.setItem("usertype", "Patient")
                vm.dashSource = "/member-dash/"
                vm.portalRoute = "/portal/member"
                break
              case "Doctor":
                sessionStorage.setItem("usertype", "Doctor")
                vm.dashSource = "/reader-dash/"
                vm.portalRoute = "/portal/doctor"
                break
              case "Reader":
                //console.log('User is type: Reader');
                if (res.decoded.user_type === 'Doctor') {
                  sessionStorage.setItem("isDoctor", true)
                }
                sessionStorage.setItem("usertype", "Reader")
                vm.dashSource = "/reader-dash/"
                vm.portalRoute = "/portal/reader"
                break
              case "Provider":
              /* Nra
              case "Doctor":
                //console.log('User is type: Doctor');
                sessionStorage.setItem("usertype", "Doctor");
                vm.dashSource = "/doctor-dash/";
                vm.portalRoute = "/portal/doctor";
                break;
              */
              case "Admin":
                //console.log('User is type: Administrator');
                sessionStorage.setItem("usertype", "Administrator")
                vm.dashSource = "/admin-dash/"
                vm.portalRoute = "/portal/admin"
                break;
              case "Super":
                sessionStorage.setItem("usertype", "Super")
                vm.portalRoute = "/portal/super-admin/siview-config"
                vm.dashSource = "/super/";
                this.updtDash("0,0,0,0");
                vm.$router.push(vm.portalRoute);
                break;
              case "Technician":
                //console.log('User is type: Globe Technician');
                sessionStorage.setItem("usertype", "Technician")
                vm.dashSource = "/technician-dash/"
                vm.portalRoute = "/portal/technician"
                break
              case "Exec":
                //console.log('User is type: Executive');
                sessionStorage.setItem("usertype", "Executive")
                window.location.href = "./roles/executive/Dashboard.html"
                break
              default:
                console.log("User Type: UNKNOWN")
            }
            sessionStorage.setItem("portalRoute", vm.portalRoute);
            vm.getDashboardInfo(this.dashSource, sessionStorage.getItem("username"))
          })
          .catch((errors) => {
            console.log(errors);
            vm.status = errors
            console.log("status: " + vm.status)
          })
      }
    },

    async getDashboardInfo(route, user) {
      if (user) {
        const url = process.env.VUE_APP_URL + route + user
        const vm = this
        await window.axios
          .get(url)
          .then((r) => r.data)
          .then((response) => {
            vm.updtDash(response)
          })
          .then(() => {
            if (sessionStorage.getItem("isTempPsw") === "true") {
              vm.$router.push(vm.portalRoute + "/my-settings")
            } else {
              vm.$router.push(vm.portalRoute)
            }
          })
          .catch((error) => {
            // vm.status = "An error occurred: " + error
            console.log(error)
          })
      }
    },

    updtDash(values) {
      var res = values.split(",")
      switch (sessionStorage.getItem("usertype")) {
        case "Patient":
          sessionStorage.setItem("memberMessages", res[0])
          sessionStorage.setItem("memberReports", res[1])
          sessionStorage.setItem("memberReferralsCount", res[2])
          sessionStorage.setItem("memberReferrals", res[3])
          sessionStorage.setItem("memberReaderDate", res[4])
          break
        case "Doctor":
        case "Reader":
          sessionStorage.setItem("readerMessages", res[0])
          sessionStorage.setItem("readerAvailable", res[1])
          sessionStorage.setItem("readerHold", res[2])
          sessionStorage.setItem("readerReports", res[3])
          break
        /* Nra
        case "Doctor":
          sessionStorage.setItem("doctorMessages", res[0]);
          sessionStorage.setItem("doctorAvailable", res[1]);
          sessionStorage.setItem("doctorHold", res[2]);
          sessionStorage.setItem("doctorReports", res[3]);
          break;
        */
        case "Administrator":
        case "Super":
          sessionStorage.setItem("adminMessages", res[0])
          sessionStorage.setItem("adminAvailable", res[1])
          sessionStorage.setItem("adminHold", res[2])
          sessionStorage.setItem("adminReports", res[3])
          break
        case "Care Provider":
          break
        case "Technician":
          sessionStorage.setItem("technicianMessages", res[0])
          sessionStorage.setItem("technicianAvailable", res[1])
          sessionStorage.setItem("technicianHold", res[2])
          sessionStorage.setItem("technicianReports", res[3])
          break
        case "Executive":
          break
        default:
          console.log("User Type: UNKNOWN")
      }
    },

    failureMsg() {
      Swal.fire({
        title: "Login failed",
        text: "Please re-enter your login info",
        type: "error",
        confirmButtonClass: "md-button md-info",
        buttonsStyling: false,
        timer: 3000
      })
    }
  }
}
</script>

<style lang="css" scoped>
.md-button {
  border: none;
  border-radius: 3px;
  position: relative;
  margin: 0.3125rem 1px;
  height: auto;
  line-height: 1.42857;
  font-size: 12px;
  font-weight: 400;
  /* text-transform: uppercase; */
  letter-spacing: 0;
}
</style>
